import { LOCALES } from 'utils/languageUtils';
import * as Yup from 'yup';
import { GREEKLISH_MAP } from './RoamingMainForm.consts';

export const buildCountryOptions = (countries, flags, banners) => {
  if (!Array.isArray(countries)) {
    return [];
  }
  const flagMap = Array.isArray(flags) ? Object.fromEntries(flags.map((it) => [it.countryId, it.src])) : {};
  const bannerMap = Array.isArray(banners) ? Object.fromEntries(banners.map((it) => [it.countryId, it.src])) : {};
  return countries.map((it) => ({
    ...it,
    image: flagMap[it.id],
    banner: bannerMap[it.id],
  }));
};

export const formValidationSchema = (labels) =>
  Yup.object({
    country: Yup.object().required(labels?.errors?.countryRequired),
    type: Yup.object().required(labels?.errors?.typeRequired),
  });

const normalize = (input) => {
  if (input == null || typeof input !== 'string') return null;
  return input
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^\p{L}\p{N}]+/gu, '');
};

const normalizeGreek = (input) => {
  if (input == null || typeof input !== 'string') return null;
  let result = normalize(input).replace(/ς/g, 'σ');
  for (const [key, value] of GREEKLISH_MAP) {
    result = result.split(key).join(value);
  }
  return result;
};

const enMatcher = (option, normalizedSearch) => {
  if (typeof option?.en == 'string') {
    const normalizedValue = normalize(option.en);
    if (normalizedValue.includes(normalizedSearch)) {
      return true;
    }
  }
  return false;
};

const elMatcher = (option, normalizeGreekSearch) => {
  if (typeof option?.el == 'string') {
    const normalizeGreekValue = normalizeGreek(option.el);
    if (normalizeGreekValue.includes(normalizeGreekSearch)) {
      return true;
    }
  }
  return false;
};

export const extractOptions = (language, value, search, options) => {
  if (typeof search !== 'string' || search.trim().length === 0) return options;

  const normalizedSearch = normalize(search);
  if (language === LOCALES.ENGLISH) {
    return options.filter((it) => enMatcher(it, normalizedSearch));
  }

  const normalizeGreekSearch = normalizeGreek(search);
  return options.filter((it) => elMatcher(it, normalizeGreekSearch));
};
